


























import Vue from 'vue'
import { FETCH_INFORMATION_DATA } from '@/store/action-types'
import { hexToRgba } from '@/services/hex-to-rgba'
import { Changelog } from '@/model/Changelog'
import ProgressCircular from '@/components/ProgressCircular.vue'

interface ComponentData {
  informationData: Changelog[]
  loading: boolean
}

export default Vue.extend({
  name: 'InformationDialog',

  components: {
    ProgressCircular
  },

  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  data (): ComponentData {
    return {
      informationData: [],
      loading: false
    }
  },

  computed: {
    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },
  },

  methods: {
    onCloseButtonClick (): void {
      this.$emit('close')
    },

    async fetchInformationData(): Promise<void> {
      this.loading = true
      try {
        this.informationData = await this.$store.dispatch(FETCH_INFORMATION_DATA)
      } catch {

      } finally {
        this.loading = false
      }
    }
  },

  mounted () {
    this.fetchInformationData()
  }

})
